import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";

const ConfirmPassordResetComponent = loadable(
  () => import("../../components/Auth/ConfirmPasswordReset")
);

const ConfirmPassordReset = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["confirm-password"],
    navigateURL: `/`,
  });

  const handlePasswordReset = async (values: any, setError: any) => {
    const url = `${APIS.FORGET_PASSWORD}`;
    let formData = {
      ...values,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        window.localStorage.removeItem("email");
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <ConfirmPassordResetComponent handlePasswordReset={handlePasswordReset} />
  );
};

export default ConfirmPassordReset;
